import React from 'react';
import { ImageProps } from '.';

const SvgCreditCardMastercard = ({ size = 48, ...props }: ImageProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={(size && Math.floor(size / 1.263157894736842)) || 38}
      fill='none'
      viewBox='0 0 48 38'
      {...props}
    >
      <rect width={47} height={37} x={0.5} y={0.5} fill='#fff' stroke='#E2E5E6' rx={7.5} />
      <path fill='#FF5A00' d='M27.928 11.925h-7.876v14.15h7.876v-14.15Z' />
      <path
        fill='#EB001B'
        d='M20.576 19a9.026 9.026 0 0 1 3.425-7.075A8.952 8.952 0 0 0 18.45 10c-4.975 0-9 4.025-9 9s4.025 9 9 9c2.1 0 4.025-.725 5.552-1.925A8.982 8.982 0 0 1 20.575 19Z'
      />
      <path
        fill='#F79E1B'
        d='M38.553 19c0 4.975-4.025 9-9 9-2.1 0-4.025-.725-5.552-1.925A8.951 8.951 0 0 0 27.428 19a9.025 9.025 0 0 0-3.425-7.075A8.937 8.937 0 0 1 29.55 10c4.978 0 9.003 4.052 9.003 9Z'
      />
    </svg>
  );
};

export default SvgCreditCardMastercard;
